import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const LANG_SESS_STRING_MAP: string = 'language_choosen';

@Injectable()
export class SetLanguageService {
  constructor(private translate: TranslateService) {}

  inizializeLanguage(): void {
    if (
      this.getSessionCurrentLanguage() == null ||
      this.getSessionCurrentLanguage() == 'null'
    ) {
      this.setBrowserLanguage();
    } else {
      this.changeLang(this.getSessionCurrentLanguage());
    }
  }

  private setBrowserLanguage(): void {
    this.translate.addLangs(['es', 'en']);
    let defaultLang = this.getLanguage(this.translate.getBrowserLang());
    this.translate.setDefaultLang(defaultLang);
    this.translate.use(defaultLang);
    this.saveSessionCurrentLanguage(defaultLang);
  }

  saveSessionCurrentLanguage(lang: string): void {
    localStorage.setItem(LANG_SESS_STRING_MAP, lang);
  }

  getSessionCurrentLanguage(): string {
    return localStorage.getItem(LANG_SESS_STRING_MAP);
  }

  private getLanguage(lang: string): string {
    if (lang == null || lang === undefined) {
      return 'es';
    }
    switch (lang) {
      case 'es': {
        return 'es';
      }
      case 'en': {
        return 'en';
      }
      default: {
        return 'es';
      }
    }
  }

  changeLang(lang: string) {
    this.translate.langs = [];
    this.translate.addLangs(['es', 'en']);
    let toSet = this.getLanguage(lang);
    this.saveSessionCurrentLanguage(toSet);
    this.translate.use(toSet);
  }
}
